import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Typography, Card } from '@chilecompra/react-kit/components'
import { Grid, CheckBox } from './QuoteStepOne.styles'

/**
 * The ClosingDate's component.
 */
const SecondCallAutomaticComponent = props => {
  const { secondCallAutomatic, handleChange } = props
  const [isFocused, setisFocused] = useState()
  const focusedFunction = () => {
    setisFocused(true)
  }
  const unfocusedFunction = () => {
    setisFocused(false)
  }

  return (
    <Grid container margin="24px 0 24px">
      <Grid container item sm direction="column" padding="2px 32px 0 0" xs={12}>
        <Typography fontWeight="bold" variant="body2">
          Ampliación de convocatoria automática
        </Typography>
        <Typography fontWeight="regular" color="black1" variant="body2">
          Al ampliar la convocatoria podrán participar todos los proveedores, independiente de su tamaño.
        </Typography>
      </Grid>
      <Grid
        container
        item
        sm={8}
        sx={{
          '&:focus-visible': {
            backgroundColor: 'yellow',
            outline: 'none'
          },

          '&.MuiGrid-root.QuoteStepOnestyles__Grid-sc-161v507-3.zqXCs.MuiGrid-container.MuiGrid-item.MuiGrid-grid-sm-8:focus-visible':
            {
              backgroundColor: 'yellow',
              outline: 'none'
            }
        }}
      >
        <Grid item sm={12}>
          <CheckBox
            checked={secondCallAutomatic}
            label="Deseo ampliar automáticamente la convocatoria."
            onChange={handleChange}
            onFocus={focusedFunction}
            onBlur={unfocusedFunction}
            style={{
              border: isFocused ? '1px solid red' : '0',
              borderRadius: isFocused ? '8px' : '0'
            }}
          />
          {secondCallAutomatic && (
            <Card {...props} color="primary" margin="0 0 5px">
              <Typography fontSize="12px" fontWeight="regular" lineHeight="16px" variant="body2">
                Si no recibes cotizaciones en tu Compra Ágil por parte de las EMT,
                <strong>
                  {' '}
                  se ampliará automáticamente la convocatoria a todos los proveedores de Mercado Público{' '}
                </strong>
                independiente de su tamaño. Este proceso se volverá a publicar en el mismo plazo que estableció
                originalmente..
              </Typography>
            </Card>
          )}
        </Grid>
      </Grid>
    </Grid>
  )
}

SecondCallAutomaticComponent.propTypes = {
  secondCallAutomatic: PropTypes.bool.isRequired,
  handleChange: PropTypes.func.isRequired
}

export default SecondCallAutomaticComponent
